/** Site-wide constants. */
export const SITE = {
  legalNameJa: "株式会社ＮｏＪｏ　Ｅｎｔｅｒｐｒｉｓｅ",
  legalNameEn: "NoJo Enterprise, Co. Ltd.",
  legalNameJaAlt: "株式会社NoJo Enterprise",
  legalNameJaRegistered: "株式会社ＮｏＪｏ　Ｅｎｔｅｒｐｒｉｓｅ",
  invoiceRegistrationDateJa: "令和5年10月1日",
  invoiceRegistrationDateEn: "October 1, 2023",
  established: "2013",
  establishedDisplayJa: "2013年12月3日",
  establishedDisplayEn: "December 3, 2013",
  capitalJpy: 50000000,
  capitalDisplayJa: "資本金 5,000万円",
  capitalDisplayEn: "Capital ¥50,000,000",
  representativeJa: "代表取締役 アダム ジョーンズ",
  representativeEn: "Representative Director Adam Jones",
  locationJa: "神奈川県横須賀市",
  locationEn: "Yokosuka, Kanagawa, Japan",
  addressFullJa: "〒238-0041 神奈川県横須賀市本町2-2-1 高村ビル202号室",
  addressFullEn: "#202 Takamura Building, 2-2-1 Honcho, Yokosuka 238-0041, Japan",
  corporateNumber: "5021001052313",
  invoiceRegistration: "T5021001052313",
  corporateNumberRegistryUrl:
    "https://www.houjin-bangou.nta.go.jp/henkorireki-johoto.html?selHouzinNo=5021001052313",
  invoiceRegistrationRegistryUrl:
    "https://www.invoice-kohyo.nta.go.jp/regno-search/detail?selRegNo=5021001052313",
  phone: "+81-46-874-7156",
  phoneDisplay: "046-874-7156",
  email: "support@nojoenterprise.com",
  primaryDomain: "nojoenterprise.com",
  taglineJa: "移動を支え、記録をつなぎ、信頼で社会を前へ。",
  taglineEn: "Supporting mobility. Connecting records. Securing trust.",
  brandLine: "Mobility · Records · Digital Infrastructure",
  brandLineJa: "モビリティ・記録・デジタル基盤",
  corporateStatementJa: "日本の実務課題を、信頼できるデジタル基盤へ。",
  corporateStatementEn:
    "Solving Japan's practical pain points through trusted digital systems.",
  productProofJa: "ETCカード・AI活用の通行記録・外貨両替",
  productProofEn: "ETC Cards · AI-Assisted Toll Receipts · Money Exchange",
};

export const LANGUAGES = {
  ja: { code: "ja", label: "日本語", short: "JA" },
  en: { code: "en", label: "English", short: "EN" },
};

export const DEFAULT_LANG = "ja";

/** Approved NoJo Enterprise brand palette. */
export const BRAND = {
  purple: "#5B2E83",
  green: "#7AC943",
  blue: "#1667B7",
  navy: "#0F1D2D",
  gray: "#6B7280",
  lightGray: "#F2F4F7",
};
